import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { importarExcelActivos } from "api/Activo.service"
import CustomButton from "common/components/Button/Button"
import Dropzone from "common/components/Dropzone"
import ImportGrid from "common/components/ImportGrid"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import { STATIC_ASSETS_URL } from "common/context/constants"
import useImportGrid from "common/hooks/useImportGrid"
import notification from "common/utils/notification"
import { checkDocumentFormat } from "features/User/utils"
import { Message } from "primereact/message"
import { useTranslation } from "react-i18next"
import { PLANTILLA_ACTIVOS } from "routes/RoutePaths"
import { OPTIONS_ACTIVOS } from "../../constants"
import { ActivosExcelProps, mapActivosImportar } from "./constant"

interface CustomFile extends File {
  path?: string
}

const ImportarActivos = () => {
  const { t } = useTranslation()
  const {
    header,
    setData,
    data,
    selectedOptions,
    fetching,
    handleSetData,
    setSelectedOptions,
    handleUpload,
  } = useImportGrid({ options: OPTIONS_ACTIVOS })

  const { handleDownloadFile } = useDownloadFileContext()

  const handleOnDrop = async (files: CustomFile[]) => {
    checkDocumentFormat(files?.length, files[0], handleSetData)
  }

  const URL_PLANTILLA_ACTIVOS = `${STATIC_ASSETS_URL}${PLANTILLA_ACTIVOS}`

  const handleDownload = () => {
    handleDownloadFile(URL_PLANTILLA_ACTIVOS)
  }

  const handleImportarActivos = async () => {
    try {
      await handleUpload(async (data: ActivosExcelProps[]) => {
        const mappedData = mapActivosImportar(data)
        const resp = mappedData && (await importarExcelActivos(mappedData))
        if (resp?.status && resp.status === STATUSCORRECT) {
          setData([])
          notification.success({
            body: `${t("importar.activos.msg.correctImport")}`,
          })
        }
      })
    } catch {
      // eslint-disable-next-line no-console
      console.log("error")
    }
  }

  return (
    <div className='tw-flex tw-flex-col tw-justify-start tw-h-full import-scroller-page'>
      <p
        className='tw-text-left'
        style={{ fontSize: "21px" }}
      >
        {t("importar.activos.title")}
      </p>

      <div className='tw-mb-3 tw-flex tw-justify-between'>
        <Message
          className='tw-w-3/4'
          severity='info'
          text={`${t("importar.activos.msgTemplate")}`}
        />
        <CustomButton
          className='!tw-bg-primary'
          onClick={handleDownload}
        >
          {t("importar.activos.downloadTemplate")}
        </CustomButton>
      </div>

      <Dropzone
        maxFiles={1}
        onDrop={handleOnDrop}
        acceptLabel='.xlsx'
        accept='.xlsx'
        fluid
      />

      <ImportGrid
        data={data}
        setData={setData}
        header={header}
        options={OPTIONS_ACTIVOS}
        dropdownStates={selectedOptions}
        setDropdownStates={setSelectedOptions}
      />

      <div className='tw-my-3 tw-mr-1 tw-flex tw-justify-end'>
        {data.length ? (
          <ButtonPrimeReact
            loading={fetching}
            onClick={handleImportarActivos}
            className='!tw-bg-primary !tw-border-none tw-text-simple-10'
          >
            {t("importar.activos.importButton")}
          </ButtonPrimeReact>
        ) : null}
      </div>
    </div>
  )
}

export default ImportarActivos
